(() => {
	const constrain = 500;
	const mouseOverContainer = document.querySelector("body");
	const ex1Layer = document.querySelector("#tilt") as HTMLElement;

	function transforms(x: number, y: number, el: HTMLElement): string {
		const box = el.getBoundingClientRect();
		const calcX = -(y - box.y - box.height / 2) / constrain;
		const calcY = (x - box.x - box.width / 2) / constrain;

		return `perspective(100px) rotateX(${calcX}deg) rotateY(${calcY}deg)`;
	}

	function transformElement(el: HTMLElement, x: number, y: number): void {
		el.style.transform = transforms(x, y, el);
	}

	mouseOverContainer.addEventListener("mousemove", (e) => {
		window.requestAnimationFrame(function () {
			transformElement(ex1Layer, e.clientX, e.clientY);
		});
	});
})();
